import Select, { selectClasses } from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';

import styled from 'shared/utils/styled';

export type CustomVariant = 'standard' | 'underline';

type SelectAccessories = Partial<{
  customVariant: CustomVariant;
}>;

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'customVariant',
})<SelectAccessories>(({ customVariant = 'standard' }) => ({
  width: '100%',
  paddingTop: 0,
  paddingBottom: 0,
  fontFamily: 'NeoSansStd',
  fontSize: 15,
  color: '#fff',
  ...(customVariant === 'underline' && {
    borderBottom: '1px solid rgba(34, 64, 96, 0.2)',
    color: 'rgb(34, 64, 96)',
  }),
  [`& .${selectClasses.select}`]: {
    fontSize: '1rem',
    minHeight: '24px !important',
    paddingTop: 6.5,
    paddingBottom: 3.5,
    paddingRight: '36px !important',
    '&:focus': {
      background: 'transparent',
    },
  },
}));

type IconButtonAccessories = Partial<{
  /**
   * Applied active styles to the button
   *
   * @default false
   */
  active: boolean;
}> &
  SelectAccessories;

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<IconButtonAccessories>(({ active = false, customVariant = 'standard' }) => ({
  padding: 3,
  background: '#fff',
  color: 'rgb(34, 64, 96)',
  ...(active && {
    transform: 'rotate(180deg)',
  }),
  ...(customVariant === 'underline' && {
    background: '#F0F3F7',
    color: 'rgb(34, 64, 96)',
  }),
  '&:hover': {
    background: '#fff',
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: 8,
  font: `400 ${theme.typography.pxToRem(15)} NeoSansStd`,
  color: '#224060',
}));

export const StyledAdornment = styled(InputAdornment)(() => ({
  position: 'absolute',
  right: 0,
}));
